import React from 'react';


interface IconProps {
  children: any;
  color?: string;
  isCssColor?: boolean;
  size?: number;
  styles?: any;
  viewBox: string;
}

function Icon({
  children,
  color = 'grey.900',
  isCssColor = false,
  size = 24,
  styles = {},
  ...props
}: IconProps) {
  return (
    <svg
      width={size}
      style={{
        display: 'block',
        margin: 0,
        width: size,
        height: size,
        ...styles,
      }}
      fill={isCssColor ? 'currentColor' : color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {children}
    </svg>
  );
}

export default Icon;
